import React, { useCallback, useContext, useRef, useState } from 'react'
import { appContext } from '../../service/AppContext';
import Popup from '../popup/Popup';
import { simulatorContext } from '../../service/SimulatorContext';
import Input from '../input/Input';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PdfTemplate from '../exportPdf/PdfTemplate';
import Button from '../buttons/Button';
import { CreateLinkAndClick } from '../exportPdf/ExportPdf';

export default function UserNamePopup() {

    const { user, setUser } = useContext(appContext);
    const { userNamePopup, setUserNamePopup } = useContext(simulatorContext);

    const [name, setName] = useState({ firstName: user.firstName, lastName: user.lastName })

    const [downloadPdf, setDownloadPdf] = useState(false);

    const HandleUpdateUserCB = useCallback(
        (key) => {
            return updateUserKey
            function updateUserKey(value) {
                setName(prev => { return { ...prev, [key]: value } })
            }
        }, [setName]);

    if (!userNamePopup)
        return

    const handleClick = () => {
        setUser(prev => ({ ...prev, ...name }));
        setDownloadPdf(true);
    }

    return (
        <Popup closePopup={() => { setUserNamePopup(false) }}>
            <h3>מלאו את הפרטים של התורם</h3>
            <div className="fields-grid-wrapper">
                <div className="fields-grid2">
                    <Input value={name.lastName} onChange={HandleUpdateUserCB('lastName')} type='text' name='last-name' id='last-name' label='שם משפחה' aria-label="שם משפחה" />
                    <Input value={name.firstName} onChange={HandleUpdateUserCB('firstName')} type='text' name='first-name' id='first-name' label='שם פרטי' aria-label="שם פרטי" />
                    <Button onClick={handleClick} label={(downloadPdf) ? "מוריד PDF.." : "אישור"} disabled={!(name.firstName || name.lastName) || downloadPdf} />
                </div>
                <div style={{ display: "none" }}>
                    {(downloadPdf) && <CreateLinkAndClick postClickCallback={() => { setUserNamePopup(false) }} />}
                </div>
            </div>

        </Popup>

    )
}
